import { render } from "./IdentityPendingModal.vue?vue&type=template&id=504a82b8&scoped=true"
import script from "./IdentityPendingModal.vue?vue&type=script&lang=js"
export * from "./IdentityPendingModal.vue?vue&type=script&lang=js"

import "./IdentityPendingModal.vue?vue&type=style&index=0&id=504a82b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504a82b8"]])

export default __exports__